angular.module('picmonic-common').factory('WebinarsService', [
  '$rootScope',
  '$state',
  '$modal',
  'UserService',
  'ResourceUpgradeModalService',
  function ($rootScope, $state, $modal, UserService, ResourceUpgradeModalService) {
    return {
      playRecorded: function (resource) {
        var self = this;
        if (resource.is_premium && (!UserService.user.user_id || UserService.user.is_trial)) {
          return self.showPremiumModal(resource);
        }

        if (resource.account_required && !UserService.user.user_id) {
          return UserService.showRegisterModal(false, '/events/webinars?recorded_id=' + resource.resource_id);
        }

        $modal.open({
          templateUrl: '/templates/modals/video-modal.html',
          windowClass: 'learn-light-modal video-modal',
          keyboard: true,
          controller: [
            '$scope',
            function ($scope) {
              $scope.videoUrl = resource.link;
              $scope.title = resource.title;
              $scope.playerVars = {
                autoplay: 1,
                controls: 2,
                color: 'white',
                fs: 0,
                modestbranding: 1,
                rel: 0,
              };
            },
          ],
        });
      },
      showPremiumModal: function (resource) {
        ResourceUpgradeModalService.show('other_resources', resource);
      },
      process: function (data) {
        var webinars = [];
        var now = moment().add(30, 'minutes');
        var self = this;
        angular.forEach(data, function (value) {
          for (var x = 0; x < value.schedules.length; x++) {
            var schedule = moment.tz(value.schedules[x].date, value.timezone);
            if (schedule > now) {
              value.date = schedule;
              value.formatted_date = schedule.tz(moment.tz.guess()).format('ddd D MMM | h:mma z');

              value.link = '/events/webinars/' + value.webinar_id;

              if (
                value.registration_url &&
                (value.registration_url.indexOf('.jpg') !== -1 ||
                  value.registration_url.indexOf('.jpeg') !== -1 ||
                  value.registration_url.indexOf('.png') !== -1)
              ) {
                value.bg_image =
                  'url(' +
                  (value.registration_url.indexOf('//') !== -1 ? '' : $rootScope.base_asset_url) +
                  value.registration_url +
                  ')';
              } else {
                slug = value.name
                  .toLowerCase()
                  .replace(/\s/gi, '-')
                  .replace(/[^A-za-z0-9.-]+?/gi, '');
                value.bg_image = 'url("https://cdn.picmonic.com/pages/wp-content/uploads/' + slug + '.jpg")';
              }

              webinars.push(value);
              if (parseInt($state.params.webinar_id, 10) === parseInt(value.webinar_id, 10)) {
                self.rsvp(value);
              }
              break;
            }
          }
        });

        return webinars;
      },
      rsvp: function (webinar) {
        $modal.open({
          templateUrl: '/templates/public/modals/webinar-rsvp.html',
          controller: [
            '$scope',
            '$interval',
            '$filter',
            'WebinarResource',
            function ($scope, $interval, $filter, WebinarResource) {
              $scope.UserService = UserService;
              $scope.webinar = webinar;
              $scope.loading = false;

              $scope.email = UserService.user.email ? UserService.user.email : '';

              var now = moment().add(30, 'minutes');
              for (var x = 0; x < $scope.webinar.schedules.length; x++) {
                var schedule = moment.tz($scope.webinar.schedules[x].date, $scope.webinar.timezone);
                if (schedule > now) {
                  $scope.schedule = x;
                  $scope.webinar.date = schedule;
                  $scope.webinar.start = schedule.tz(moment.tz.guess()).format('llll z');

                  $scope.gcal_link =
                    'https://www.google.com/calendar/event?action=TEMPLATE' +
                    '&dates=' +
                    $filter('date')(schedule.unix() * 1000, "yMMddTHHmm00'Z'", '+0000') +
                    '%2F' +
                    $filter('date')(schedule.unix() * 1000 + 1800000, "yMMddTHHmm00'Z'", '+0000') +
                    '&text=' +
                    encodeURIComponent(webinar.name) +
                    '&details=' +
                    encodeURIComponent(webinar.description);
                  $scope.outlook_link =
                    '/api/v3/webinars/' +
                    webinar.webinar_id +
                    '/cal' +
                    '?timestamp=' +
                    schedule.unix() +
                    '&summary=' +
                    encodeURIComponent(webinar.name) +
                    '&description=' +
                    encodeURIComponent(webinar.description);
                  break;
                }
              }

              $scope.diff = Math.floor(schedule.unix() - Date.now() / 1000);

              interval = $interval(function () {
                $scope.diff--;
              }, 1000);

              $scope.$on('$destroy', function () {
                if (interval) {
                  $interval.cancel(interval);
                }
              });

              $scope.days = function () {
                var days = Math.floor($scope.diff / (60 * 60 * 24));
                if (days < 10) {
                  days = '0' + days;
                }
                return days;
              };

              $scope.hours = function () {
                var hours = Math.floor($scope.diff / (60 * 60)) % 24;
                if (hours < 10) {
                  hours = '0' + hours;
                }
                return hours;
              };

              $scope.minutes = function () {
                var minutes = Math.floor($scope.diff / 60) % 60;
                if (minutes < 10) {
                  minutes = '0' + minutes;
                }
                return minutes;
              };

              $scope.seconds = function () {
                var seconds = Math.floor($scope.diff) % 60;
                if (seconds < 10) {
                  seconds = '0' + seconds;
                }
                return seconds;
              };

              $scope.register = function () {
                $scope.error = '';
                if (!$scope.email) {
                  $scope.error = 'Please enter a valid email address.';
                  return;
                }

                if ($scope.phone && $scope.phone.toString().length !== 10) {
                  $scope.error = 'Invalid phone number.';
                  return;
                }

                if (!$scope.loading) {
                  $scope.loading = true;
                  WebinarResource.save(
                    {
                      webinar_id: $scope.webinar.webinar_id,
                      resource_type: 'register',
                      webinar_name: $scope.webinar.name,
                      schedule: $scope.schedule,
                      email: $scope.email,
                      phone: $scope.phone,
                    },
                    function (data) {
                      $scope.loading = false;
                      $scope.gcal_link +=
                        '&location=' +
                        encodeURIComponent(data.live_room_url) +
                        '&sprop=' +
                        encodeURIComponent(data.live_room_url);
                      $scope.outlook_link += '&location=' + encodeURIComponent(data.live_room_url);

                      if (UserService.user.user_id) {
                        $scope.tab = 'success';
                      } else {
                        $rootScope.registerModal = {
                          registerTitle: 'Thanks for RSVPing!',
                          email: $scope.email,
                        };
                        UserService.showRegisterModal(
                          false,
                          null,
                          null,
                          'A confirmation email is on its way to your inbox!<br /><a href="' +
                            $scope.gcal_link +
                            '" onclick="atlasEvent(\'click\', \'add-to-gcal\')" target="_blank" class="pls-btn pls-btn--orange pls-white m-t-1" style="min-width: 290px;">ADD TO MY GOOGLE CALENDAR</a><br /><a href="' +
                            $scope.outlook_link +
                            '" onclick="atlasEvent(\'click\', \'add-to-outlook\')" target="_self" class="pls-btn pls-btn--orange  pls-white m-t-1 m-b-1"  style="min-width: 290px;">ADD TO MY OUTLOOK CALENDAR</a><hr /> <strong>Finish creating a free account in 10 seconds:</strong>'
                        );
                        $scope.$close();
                      }
                    },
                    function (error) {
                      $scope.loading = false;
                      if (error && error.data && error.data.email) {
                        $scope.error = error.data.email.join(' ');
                      } else if (error && error.data && error.data.phone) {
                        $scope.error = error.data.phone.join(' ');
                      } else if (error && error.data && error.data.name) {
                        $scope.error = error.data.name.join(' ');
                      } else {
                        $scope.error = 'There was an error with your RSVP.';
                      }
                    }
                  );
                }
              };
            },
          ],
        });
      },
    };
  },
]);
